import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ListGroup,
  Image,
  Form,
} from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import Preloader from "../../shared/PreLoaders";
import { Bar } from "react-chartjs-2";
import { logActivity } from "../../utils/LogActivity";
import { Authorization } from "../../Context/Authorization";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const MemberProfile = () => {
  const [ranges, setRanges] = useState([]);
  const [vfcData, setVfcData] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedVfc, setSelectedVfc] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [memberToShow, setMemberToShow] = useState(null);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    setLoading(true);
    const fetchRange = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/ranges`, config);
        const data = response.data;
        setRanges(data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
      setLoading(false);
    };

    fetchRange();
  }, [Api]);

  const handleRangeChange = async (e) => {
    const rangeId = e.target.value;
    setSelectedRange(rangeId);
    setSelectedVfc("");
    setMemberData([]);
    setSelectedMember(null);
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.post(
        `${Api}/api/vfcs/vfcs-by-range`,
        {
          rangeId,
        },
        config
      );
      const data = response.data;

      if (Array.isArray(data.vfcs)) {
        setVfcData(data.vfcs);
      } else {
        console.error("API did not return an array", data);
      }
    } catch (err) {
      console.error("Error fetching VFCs by range", err);
    }
    setLoading(false);
  };

  const handleVfcChange = async (event) => {
    const vfcId = event.target.value;
    setSelectedVfc(vfcId);
    setLoading(true);
    try {
      const config = Authorization();
      const response = await axios.get(
        `${Api}/api/members/getMembersProfile/${vfcId}`,
        config
      );
      setMemberData(response.data.members);
      await logActivity(
        userId,
        "Viewed Member Profile",
        "Member Profile Page",
        Api
      );
    } catch (error) {
      console.error("Error fetching members", error);
    }
    setLoading(false);
  };

  const handleMemberChange = (e) => {
    const member = memberData.find((m) => m._id === e.target.value);

    setSelectedMember(member);
  };

  const handleViewClick = async () => {
    if (!selectedMember) return;
    setLoading(true);

    try {
      const config = Authorization();
      const response = await axios.get(
        `${Api}/api/members/getMemberLoanDetails/${selectedMember._id}`,
        config
      );

      const { member, loans } = response.data;

      // Add the fetched loans to selectedMember
      setMemberToShow({ ...member, loans });

      await logActivity(
        userId,
        `Viewed Loan Details for ${member.name}`,
        "MemberProfile Page",
        Api
      );
    } catch (err) {
      console.error("Error fetching member loan details", err);
    }

    setLoading(false);
  };

  const generateChartData = (repaymentHistory = []) => {
    return {
      labels: repaymentHistory.map((item) => item.month),
      datasets: [
        {
          label: "Repayment Amount",
          data: repaymentHistory.map((item) => item.amount),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
        },
      ],
    };
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Member Profile</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Member Profile
            </li>
          </ol>
        </nav>
      </div>
      <Container className="my-5">
        <>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <p className="card-description">Member Selection Form</p>
                <form>
                  <Row>
                    <Col xs={4}>
                      <Form.Group controlId="Range" className="mb-3">
                        <Form.Label>Range</Form.Label>
                        <div className="input-container">
                          <Form.Control
                            as="select"
                            value={selectedRange}
                            onChange={handleRangeChange}
                          >
                            <option value="">Select Range</option>
                            {ranges.map((range) => (
                              <option key={range._id} value={range._id}>
                                {range.rangeName}
                              </option>
                            ))}
                          </Form.Control>
                        </div>
                      </Form.Group>
                    </Col>
                    <Col xs={4}>
                      <Form.Group controlId="vfcName" className="mb-3">
                        <Form.Label>VFC Name</Form.Label>
                        <div className="input-container">
                          <Form.Control
                            as="select"
                            value={selectedVfc}
                            onChange={handleVfcChange}
                          >
                            <option value="">Select VFC</option>
                            {vfcData.map((vfc) => (
                              <option key={vfc._id} value={vfc._id}>
                                {vfc.vfcName}
                              </option>
                            ))}
                          </Form.Control>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col xs={4}>
                      <Form.Group controlId="member" className="mb-3">
                        <div className="input-container">
                          <Form.Label>Member</Form.Label>
                          <Form.Control
                            as="select"
                            value={selectedMember ? selectedMember._id : ""}
                            onChange={handleMemberChange}
                          >
                            <option value="">Select Member</option>
                            {memberData.map((member) => (
                              <option key={member._id} value={member._id}>
                                {member.name}
                              </option>
                            ))}
                          </Form.Control>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-icon-text mt-3"
                    onClick={handleViewClick}
                  >
                    <i className="mdi mdi-file-check btn-icon-prepend"></i>
                    View
                  </button>
                  <button className="btn btn-light mt-3">Cancel</button>
                </form>
              </div>
            </div>
          </div>

          {memberToShow && (
            <Row>
              <Col md={4}>
                <Card className="mb-3">
                  <Card.Body className="text-center">
                    {memberToShow?.profilePicture && (
                      <Image
                        src={memberToShow.profilePicture}
                        roundedCircle
                        fluid
                        style={{ width: "150px" }}
                      />
                    )}

                    <h3 className="mt-3">{memberToShow.name}</h3>
                    <p>{memberToShow.work}</p>
                    <p>
                      <strong>VFC Code:</strong> {memberToShow.vfcCode?.vfcCode}
                    </p>
                    {memberToShow?.signature && (
                      <Image
                        src={memberToShow.signature}
                        fluid
                        style={{ marginTop: "20px", width: "100px" }}
                      />
                    )}
                  </Card.Body>
                </Card>

                <Card className="mb-3">
                  <Card.Header>
                    <p className="card-description">Additional Details</p>
                  </Card.Header>
                  <Card.Body>
                    <ListGroup variant="flush">
                      <ListGroup.Item>
                        <strong>Bank:</strong> {memberToShow.bank}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Branch:</strong> {memberToShow.branch}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Account Number:</strong>{" "}
                        {memberToShow.accountNumber}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>IFSC Code:</strong> {memberToShow.ifscCode}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Community:</strong> {memberToShow.community}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Educational Qualification:</strong>{" "}
                        {memberToShow.educationalQualification}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Income:</strong> {memberToShow.income}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Marital Status:</strong>{" "}
                        {memberToShow.maritialStatus}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Family Member Details:</strong>{" "}
                        {memberToShow.familyMemberDetails}
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={8}>
                <Card className="mb-3">
                  <Card.Header>
                    <p className="card-description">User Info</p>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <ListGroup variant="flush">
                          <ListGroup.Item>
                            <strong>First Name:</strong> {memberToShow.name}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Address:</strong> {memberToShow.address}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Father/Husband:</strong>{" "}
                            {memberToShow.fatherOrHusband}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Panchayath:</strong>{" "}
                            {memberToShow.panchayath}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Pin Code:</strong> {memberToShow.pinCode}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>District:</strong> {memberToShow.district}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Aadhar:</strong> {memberToShow.aadhar}
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>

                      <Col md={6}>
                        <ListGroup variant="flush">
                          <ListGroup.Item>
                            <strong>Phone:</strong> {memberToShow.phone}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Email:</strong> {memberToShow.eMail}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Village:</strong> {memberToShow.village}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Father/Husband Name:</strong>{" "}
                            {memberToShow.fatherOrHusbandName}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Thaluk:</strong> {memberToShow.thaluk}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>WhatsApp No:</strong>{" "}
                            {memberToShow.whatsAppNo}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <strong>Ration Card:</strong>{" "}
                            {memberToShow.rationCard}
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header>
                    <p className="card-description">Loan History</p>
                  </Card.Header>
                  <Card.Body>
                    {memberToShow.loans?.map((loan, index) => (
                      <div key={index} className="mb-4">
                        <h5>Loan No: {loan.subLoans?.[0]?.subLoanId}</h5>
                        <Bar
                          data={generateChartData(loan.repaymentHistory || [])}
                        />
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </>
      </Container>
    </div>
  );
};

export default MemberProfile;
